var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GoAlert } from 'react-icons/go';
import { Flex, Text, Box, Icon } from "./..";
import { getAPIErrorMessage } from './getAPIErrorMessage';
export var Message = function (_a) {
    var messageProp = _a.message, descriptionProp = _a.description, helperProp = _a.helper, actionsProp = _a.actions, _b = _a.icon, CustomIcon = _b === void 0 ? GoAlert : _b, _c = _a.mode, mode = _c === void 0 ? 'default' : _c, response = _a.response, lss = _a.lss, textLss = _a.textLss;
    var messageData = response ? getAPIErrorMessage(response) : {};
    var responseMessage = messageData.message, responseDescription = messageData.description, responseHelper = messageData.helper, responseActions = messageData.actions;
    var message = messageProp || responseMessage;
    var description = descriptionProp || responseDescription;
    var helper = helperProp || responseHelper;
    var actions = actionsProp || responseActions || [];
    var isInlineMode = mode === 'inline';
    var alignment = isInlineMode ? 'left' : 'center';
    var marginTop = isInlineMode ? 'md' : 'lg';
    return (React.createElement(Flex, { lss: __assign({ alignItems: isInlineMode ? 'start' : 'center', justifyContent: alignment, flexDirection: 'column', textAlign: alignment, m: 'auto', px: 'xxl' }, lss) },
        !isInlineMode && CustomIcon ? React.createElement(Icon, { as: CustomIcon, size: 30 }) : null,
        React.createElement(Text, { as: "h1", lss: __assign({ mt: marginTop, mb: 0, fontWeight: isInlineMode ? 'bold' : 'regular', textAlign: alignment, textScale: isInlineMode ? 'content' : 'heading3' }, textLss) }, message),
        description && (React.createElement(Text, { as: "p", lss: __assign({ textScale: isInlineMode ? 'control' : 'content', mt: marginTop, mb: 0, textAlign: alignment }, textLss) }, description)),
        actions.length ? (React.createElement(Flex, { lss: { mt: 'xl' } }, actions.map(function (action, key) { return (React.createElement(Box, { key: key, lss: { mx: 'sm' } }, action)); }))) : null,
        helper && (React.createElement(Text, { lss: __assign({ textScale: 'caption', mt: 'md', fontWeight: 'regular', textAlign: alignment }, textLss) }, helper))));
};
//# sourceMappingURL=Message.js.map